import { Radio } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Locale } from "../../utils";
import { setCurrentLanguage } from "../../utils/redux/actions/CustomPage";
import { getCurrentLanguage } from "../../utils/redux/reducers/CustomPage";

const i18n = Locale.getInstance();

const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(getCurrentLanguage);

  const handleChange = (e) => {
    dispatch(setCurrentLanguage(e.target.value));
  };

  return (
    <Radio.Group value={currentLanguage} onChange={handleChange} buttonStyle="solid">
      <Radio.Button value="ug">{i18n.t("customPage.languageUyghur")}</Radio.Button>
      <Radio.Button value="zh">{i18n.t("customPage.languageChinese")}</Radio.Button>
    </Radio.Group>
  );
};

export default LanguageSwitcher;


